// @ts-ignore
import googleTagManager from '@analytics/google-tag-manager';
import Analytics from 'analytics';
import { pageMapping, analyticsEventType } from '../../../utils/GoogleAnalytics';

const AnalyticsService = Analytics({
  app: 'Ecommbx',
  plugins: [
    {
      name: 'ecommbx-plugin',
      page: ({ payload }: { payload: { properties: { pathname: string } } }) =>
        pageMapping(payload.properties.pathname),
      track: ({
        payload,
      }: {
        payload: { properties: { eventType: analyticsEventType; targetName: string; targetValue: string } };
      }) => payload.properties.eventType,
    },
    googleTagManager({ containerId: 'G-YDLG7KSBJN' }),
  ],
});

export { AnalyticsService };
